<template>
  <div
    class="web-panel-dashboard"
    :class="{'-show-header': showHeader, '-nav-open': openNavigation, '-focus-mode': focusMode }"
  >
    <WebPanelNavigation
      v-if="navigation"
      class="navmenu"
      :navigation="navigation"
      :open="openNavigation"
    />
    <div class="maincontent">
      <WebPanelHeader
        class="header"
        :title="title"
        :user="user"
        :dropdownItems="dropdownItems"
        v-if="showHeader"
      />
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { watch, ref, provide, computed, createComponent } from '@vue/composition-api';
import { useWebPanel } from './hooks';
import useMQ from './hooks/mq';
import WebPanelNavigation from './WebPanelNavigation';
import WebPanelHeader from './WebPanelHeader';

export default createComponent({
  name: 'WebPanelDashboard',
  components: {
    WebPanelNavigation,
    WebPanelHeader,
  },
  props: {
    navigation: { type: Array },
    user: { type: Object },
    dropdownItems: { type: Array },
  },
  setup ({ navigation }) {
    const { title, showHeader, isNavigationOpen, isNavigationEnabled, focusMode } = useWebPanel();
    const { tabletLayout } = useMQ();
    const isPageAttached = ref(false);
    watch(() => navigation, () => { isNavigationEnabled.value = Boolean(navigation); });
    provide('webPanelAPI', {
      notifyPageAttached: () => { isPageAttached.value = true; },
    });
    const openNavigation = computed(() => {
      return isPageAttached.value && (tabletLayout.value ? isNavigationOpen.value : true) && !focusMode.value;
    });
    return {
      title,
      focusMode,
      tabletLayout,
      showHeader,
      openNavigation,
      isPageAttached,
    };
  },
});
</script>

<style lang="postcss" scoped>
.web-panel-dashboard {
  position: relative;
  display: flex;
  width: 100%;

  & > .maincontent {
    flex: 1 1 auto;
    width: 100%;
    padding-bottom: 6rem;
  }
  & .burger {
    display: none;
  }
  &.-show-header {
    & .maincontent {
      padding-top: 6rem;
    }
  }

  &.show-nav-menu {
    & .burger {
      display: flex;
    }
  }

  & .header {
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
  }
  @media (--desktop) {
    &.-nav-open {
      & .header {
        width: calc(100% - 30rem);
        will-change: width;
        transform: translateZ(0);
        transition: width 0.3s ease;
      }
    }
  }

  & .navmenu {
    width: 0;
    flex-shrink: 0;
  }
  @media (--desktop) {
    & .navmenu {
      width: 30rem;
    }
    &.-focus-mode {
      & .navmenu {
        width: 0rem;
      }
    }
  }
}
</style>
